import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 根路径：区域选择页
  {
    path: '/',
    name: 'RegionSelect',
    component: () => import('@/views/RegionSelect.vue')
  },

  // ============ 国内版路由 ============
  {
    path: '/cn',
    redirect: '/cn/home'
  },
  {
    path: '/cn/home',
    name: 'cn-home',
    component: () => import('@/regions/cn/views/Home.vue')
  },
  {
    path: '/cn/about',
    name: 'cn-about',
    component: () => import('@/regions/cn/views/About.vue')
  },
  {
    path: '/cn/contact',
    name: 'cn-contact',
    component: () => import('@/regions/cn/views/Contact.vue')
  },
  {
    path: '/cn/news',
    name: 'cn-news',
    component: () => import('@/regions/cn/views/News.vue')
  },
  {
    path: '/cn/games',
    name: 'cn-games',
    component: () => import('@/regions/cn/views/Games.vue')
  },
  {
    path: '/cn/download',
    name: 'cn-download',
    component: () => import('@/regions/cn/views/Download.vue')
  },
  {
    path: '/cn/community',
    name: 'cn-community',
    component: () => import('@/regions/cn/views/Community.vue')
  },
  {
    path: '/cn/privacy',
    name: 'cn-privacy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/cn/user',
    name: 'cn-user',
    component: () => import('@/regions/cn/views/AccountDeletion.vue')
  },

  // ============ 海外版路由 ============
  {
    path: '/global',
    redirect: '/global/home'
  },
  {
    path: '/global/home',
    name: 'global-home',
    component: () => import('@/regions/global/views/Home.vue')
  },
  {
    path: '/global/about',
    name: 'global-about',
    component: () => import('@/regions/global/views/About.vue')
  },
  {
    path: '/global/contact',
    name: 'global-contact',
    component: () => import('@/regions/global/views/Contact.vue')
  },
  {
    path: '/global/news',
    name: 'global-news',
    component: () => import('@/regions/global/views/News.vue')
  },
  {
    path: '/global/games',
    name: 'global-games',
    component: () => import('@/regions/global/views/Games.vue')
  },
  {
    path: '/global/download',
    name: 'global-download',
    component: () => import('@/regions/global/views/Download.vue')
  },
  {
    path: '/global/privacy',
    name: 'global-privacy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/global/user',
    name: 'global-user',
    component: () => import('@/regions/global/views/AccountDeletion.vue')
  },

  // 兜底：未知路径重定向到区域选择
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
